<template>
  <section class="page-inbound" :class="{ 'rtl': locale === 'ar' }">
    <section class="stepQuote">
      <div class="containerMini">
        <div class="headerBlock_rr">
          <BaseBackButtonNew @back="back"/>
          <slot name="logo">
            <Logo
              :linkName="logoLinkName"
              @click="$emit('clickLogo')"
            >
              <template v-if="$slots['logo-first-line']" #logo-first-line>
                <slot name="logo-first-line"></slot>
              </template>

              <template v-if="$slots['logo-second-line']" #logo-second-line>
                <slot name="logo-second-line"></slot>
              </template>
            </Logo>
          </slot>
        </div>
        <BaseError
            :message="errorMessage_"
            v-if="errorMessage_"
            @reload="onErrorPageReload"
            @clickGoHome="onErrorPageClickGoHome"
            @clickWhatsApp="onErrorPageClickWhatsApp"
            @clickPhone="onErrorPageClickCallUs"
        />
        <template v-else>
          <ProgressBar v-if="(steps || step) && !disableProgressBar" :steps="steps" :step="step" :from-step="fromStep"/>
          <InboundInfo v-if="info" class="inbound-info_flow" @clickPlan="$emit('clickPlan')" />
            <div class="boxForm" :class="formClasses">
              <Loader v-show="loading" class="formLoader"/>
              <slot v-if="loading" name="loading-post-content" />
              <div v-show="!loading">
                  <slot></slot>
              </div>
            </div>
        </template>
      </div>
    </section>
    <template v-if="logoAffinity">
      <div class="affinityImage">
        <img :src="`data:image/png;base64,${logoAffinity}`"/>
      </div>
    </template>
    <ContactUs @click="showNeedHelpPopup()" />
    <ContactUsPopup v-model="needHelp" :excluded-countries="excludedCountries">
      <template v-if="$slots['privacy-policy']" #privacy-policy>
        <slot name="privacy-policy"></slot>
      </template>
    </ContactUsPopup>
  </section>
</template>

<script>
import Logo from './Logo.vue'
import Loader from './Loader.vue'
import ProgressBar from './ProgressBar.vue'
import ContactUs from './need-help/ContactUs.vue'
import ContactUsPopup from './need-help/ContactUsPopup.vue'
import BaseError from './errors/BaseError.vue'
import BaseBackButtonNew from './buttons/BaseBackButtonNew.vue'
import InboundInfo from './InboundInfo.vue'
export default {
  name: 'BaseFormLayout',
  props: {
    steps: Number,
    step: Number,
    loading: Boolean,
    back: Function,
    errorMessage: { type: [String, Error], default: '' },
    disableProgressBar: { type: Boolean, default: false },
    formClasses: { type: Array, dafault: [] },
    logoLinkName: { type: String, default: 'Home' },
    info: { type: Boolean, default: false },
    logoAffinity: { type: String, default: '' },
    excludedCountries: { type: Array, default: () => [] }
  },
  components: {
    Logo,
    ProgressBar,
    ContactUs,
    BaseError,
    Loader,
    ContactUsPopup,
    BaseBackButtonNew,
    InboundInfo
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    errorMessage_ () {
      return this.errorMessage
    }
  },
  data () {
    return {
      needHelp: false,
      fromStep: null
    }
  },

  mounted () {
    // eslint-disable-next-line no-unused-expressions
    this.$ee?.$on('showContactUs', this.showNeedHelpPopup)
  },

  methods: {
    onErrorPageReload () {
      this.$emit('errorPageReload')
      this.$router.go()
    },
    onErrorPageClickGoHome () {
      this.$emit('errorPageClickGoHome')
    },
    onErrorPageClickWhatsApp () {
      this.$emit('errorPageClickWhatsApp')
    },
    onErrorPageClickCallUs () {
      this.$emit('errorPageClickCallUs')
    },
    showNeedHelpPopup () {
      this.needHelp = true
    },
    getLastStep () {
      return +sessionStorage.getItem('progressLastStep') || null
    },
    setLastStep (step) {
      sessionStorage.setItem('progressLastStep', step)
    }
  },
  watch: {
    step () {
      const lastStep = this.getLastStep()
      this.fromStep = lastStep || (this.step === 1 ? 1 : this.step - 1)
      this.setLastStep(this.step)
    }
  }
}
</script>

<style lang="scss">
.formLoader {
  top: 50%;
  left: 50%;
  margin-top: -25px!important;
  margin-left: -25px!important;
  position: absolute;
}
.affinityImage {
  display: flex;
  justify-content: center;
  max-width: 128px;
  padding: 10px;
  border-radius: 14px;
  background: #fff;
  margin: 0 auto;

  img{
    width: 100%;
    height: auto;
  }
}
</style>
